import { find, isEmpty } from 'lodash';

export const checkIsSelectedParent = ({ path, pathname, children }) => {
  if (children?.length) {
    const isSelectedChild =
      children?.filter((child) => checkIsSelectedChild({ path: child?.path, pathname, parentPath: path }))?.length > 0;

    return isSelectedChild;
  } else return path === pathname;
};

export const checkIsSelectedChild = ({ path, pathname, parentPath }) => {
  const routePath = path ? `${parentPath}/${path}` : parentPath;
  return routePath === pathname;
};

export const filterMenuByAccess = ({ routeList, accessPermission }) => {
  if (isEmpty(accessPermission)) return;

  const access = JSON.parse(accessPermission);

  let routes = routeList?.map((route) => {
    let isGranted = true;

    const accessByParentRoute = access[route?.id];

    const children = route?.children?.filter(({ id, showInSideBar }) => {
      const isExist = find(accessByParentRoute, { path: id })?.permission?.isCanRead;
      return isExist && route && showInSideBar;
    });

    //temporary code

    if (accessByParentRoute?.length < 1 && route?.id !== 'main-dashboard') isGranted = false;

    return {
      ...route,
      children,
      isGranted,
    };
  });

  routes = routes?.filter(({ showInSideBar, isGranted }) => showInSideBar && isGranted);

  return routes;
};
